const empresa_notificacao_listar = {
	name: "empresa-notificacao-listar",
	path: "/empresas/:empresaPk/notificacoes",
	component: () =>
		import("@/views/notificacao/notificacao_listar/Notificacoes.vue"),
	meta: {
		// # TODO adicionar permissao correta
		rule: ["autenticadosuperuser", "notificacaovisualizar"]
	}
};


export default [
	empresa_notificacao_listar
];
